
export const finalProjectStatusTypes = {
    approved: "approved",
    processing: "processing",

}
